import React, { useState } from 'react';
import './Contact.css';

const Contact = ({ t }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    
    // Simulate form submission
    // Replace this with your actual form handling logic
    setTimeout(() => {
      setStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setStatus(null), 3000);
    }, 1500);
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="contact-info">
          <h2>{t.contact.title}</h2>
          <p>{t.contact.subtitle}</p>
          <div className="contact-details">
            <div className="contact-item">
              <div className="contact-icon">📍</div>
              <div className="contact-item-content">
                <h4>{t.contact.address}</h4>
                <p>{t.contact.addressValue}</p>
                <p className="postal-code">{t.contact.postalCode}</p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">✉</div>
              <div className="contact-item-content">
                <h4>{t.contact.email}</h4>
                <p>
                  <a href="mailto:info@armarayan.com">info@armarayan.com</a>
                </p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">☎</div>
              <div className="contact-item-content">
                <h4>{t.contact.phone}</h4>
                <p dir="ltr">
                  <a href="tel:+982100000000">+98 21 XXXX XXXX</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-form-container">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                className="form-input"
                placeholder={t.contact.form.name}
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                className="form-input"
                placeholder={t.contact.form.email}
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                className="form-textarea"
                placeholder={t.contact.form.message}
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="form-submit" disabled={status === 'sending'}>
              {status === 'sending' ? t.contact.form.sending : `${t.contact.form.submit} →`}
            </button>
            {status === 'success' && (
              <p className="form-success">{t.contact.form.success}</p>
            )}
            {status === 'error' && (
              <p className="form-error">{t.contact.form.error}</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
